import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// FINAL ARCHITECTURE (Architect directive, Option 2):
// The root path "/" belongs to the static Masterpiece (#static-home in index.html).
// React mounts ONLY on sub-routes (/university, /exchange, /codex, /radio, ...).
const isRoot = window.location.pathname === "/";
const staticHome = document.getElementById("static-home");

if (!isRoot) {
  if (staticHome) staticHome.remove();

  const rootEl = document.getElementById("root");
  const tree = (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // react-snap hydration support (see reactSnap config in package.json)
  if (rootEl.hasChildNodes()) {
    hydrateRoot(rootEl, tree);
  } else {
    createRoot(rootEl).render(tree);
  }
}
